import React from "react";
import "./Profile.css";

function Profile({selectedCard}) {
  const { email,
    phone} = selectedCard;

	return (
    <section className="profile">
      <div className='profile-container'>
        <p className="profile__description">Клиенты видят в нем эксперта по вопросам разработки комплексных решений финансовых продуктов, включая такие аспекты, как организационная структура, процессы, аналитика и ИТ-компоненты. Он помогает клиентам лучше понимать структуру рисков их бизнеса, улучшать процессы за счет применения новейших технологий и увеличивать продажи, используя самые современные аналитические инструменты.</p>
        <p className="profile__description">В работе с клиентами недостаточно просто решить конкретную проблему или помочь справиться с трудностями. Не менее важно уделять внимание обмену знаниями: "Один из самых позитивных моментов — это осознание того, что ты помог клиенту перейти на совершенно новый уровень компетентности, уверенность в том, что после окончания проекта у клиента есть все необходимое, чтобы дальше развиваться самостоятельно".</p>
        <p className="profile__description">Помимо разнообразных проектов для клиентов финансового сектора, Сорин ведет активную предпринимательскую деятельность. Он является совладельцем сети клиник эстетической медицины в Швейцарии, предлагающей инновационный подход к красоте, а также инвестором других бизнес-проектов.</p>
      </div>
      <div className="contact__container">
        <div className="contact__block">
          <div className="phone__image"></div>
          <p className="contact__text">{phone}</p>
        </div>
        <div className="contact__block">
          <div className="email__image"></div>
          <p className="contact__text">{email}</p>
        </div>
      </div>
    </section>
	)
}

export default Profile;